import React, { useState, useEffect } from 'react';
import '../../styles/AnimatedText.scss';

interface AnimatedTextProps {
  text: string;
  delay?: number;
  repeatDelay?: number;
}

const AnimatedText: React.FC<AnimatedTextProps> = ({ 
  text, 
  delay = 100,
  repeatDelay = 2000 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  // Split the text into first word and rest
  const firstWord = text.split(' ')[0];
  const restOfText = text.split(' ').slice(1).join(' ');

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!isDeleting && currentIndex < restOfText.length) {
      // Typing phase
      timeout = setTimeout(() => {
        setDisplayedText(restOfText.slice(0, currentIndex + 1));
        setCurrentIndex(prev => prev + 1);
      }, delay);
    } else if (isDeleting && currentIndex > 0) {
      // Deleting phase
      timeout = setTimeout(() => {
        setDisplayedText(restOfText.slice(0, currentIndex - 1));
        setCurrentIndex(prev => prev - 1);
      }, delay / 2);
    } else if (currentIndex === restOfText.length) {
      // Pause at full text
      timeout = setTimeout(() => {
        setIsDeleting(true);
      }, repeatDelay);
    } else if (currentIndex === 0) {
      // Pause at empty text
      timeout = setTimeout(() => {
        setIsDeleting(false);
      }, repeatDelay / 2);
    }

    return () => clearTimeout(timeout);
  }, [currentIndex, isDeleting, restOfText, delay, repeatDelay]);

  return (
    <h1 className='fw-bold fs-1'>
      <span className="animated-text">
        <span className="static-text">{firstWord} </span>
        <span className="dynamic-text">
          {displayedText}
          <span className="cursor"></span>
        </span>
      </span>
    </h1>
  );
};

export default AnimatedText; 